import { useState } from 'react';

import { useSharedState } from 'sharedStateProvider';
import { changeUserStatus, deleteAdmin, deleteUser } from 'api/users';
import { UserType } from 'types/user-types';

type dangerModalType = 'block' | 'unblock' | 'delete' | '';

export const useUserEdit = ({
  onChange,
  isAdmin,
}: {
  onChange: () => void;
  isAdmin: boolean;
}) => {
  const { notify } = useSharedState();
  const [deletingUserId, setDeletingUserId] = useState<string>('');
  const [dangerType, setDangerType] = useState<dangerModalType>('');
  const [dangerDescription, setDangerDescription] = useState<string>('');
  const blockUserText = `Вы действительно хотите заблокировать администратора`;
  const unblockUserText = `Вы действительно хотите разблокировать администратора`;
  const deleteUserText = `Вы действительно хотите удалить администратора`;

  const confirmDanger = async () => {
    switch (dangerType) {
      case 'block':
        changeUserStatus(deletingUserId, 'inactive')
          .then(() => {
            notify('Пользователь заблокирован', 'success');
            onChange();
          })
          .catch((error: any) => {
            let err = error.response.data.error;
            notify(err, 'danger', 'Ошибка при блокировке пользователя');
          });
        break;
      case 'unblock':
        changeUserStatus(deletingUserId, 'active')
          .then(() => {
            notify('Пользователь разблокирован', 'success');
            onChange();
          })
          .catch((error: any) => {
            let err = error.response.data.error;
            notify(err, 'danger', 'Ошибка при разблокировке пользователя');
          });
        break;
      case 'delete':
        isAdmin
          ? deleteAdmin(deletingUserId)
          : deleteUser(deletingUserId)
              .then(() => {
                notify('Пользователь удалён', 'success');
                onChange();
              })
              .catch((error: any) => {
                let err = error.response.data.error;
                notify(err, 'danger', 'Ошибка при удалении пользователя');
              });
        break;
      default:
        break;
    }
  };

  const onDangerModal = (user: UserType, type: dangerModalType) => {
    setDeletingUserId(user.id || '');
    let userName = `${user.first_name} ${user.last_name}`;

    switch (type) {
      case 'block':
        setDangerType('block');
        setDangerDescription(blockUserText + ` "${userName}"?`);
        break;
      case 'unblock':
        setDangerType('unblock');
        setDangerDescription(unblockUserText + ` "${userName}"?`);
        break;
      case 'delete':
        setDangerType('delete');
        setDangerDescription(deleteUserText + ` "${userName}"?`);
        break;
      default:
        break;
    }
  };

  return {
    dangerDescription,
    confirmDanger,
    onDangerModal,
  };
};
